export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_223e9364-297a-4386-af8e-a5b20ef33734/artifacts/i0ors4k0_teslam.png";

export default function Logo({ className = "h-10", size = 40 }) {
  return (
    <img
      src={LOGO_URL}
      alt="TESLAM"
      data-testid="teslam-logo"
      style={{ height: size }}
      className={className}
    />
  );
}
